import axios from 'axios';
import { appConfig } from '../app.config';

export type PersonForm = {
  firstName: string;
  lastName: string;
  email: string;
  model: string;
  postal: string;
  optin?: string;
};

export class LeadService {
  static async sendLead(form: PersonForm, lang: string = 'en') {
    /* 
      const payload = {
      originCountry: 'CA',
      language: 'EN',
      brand: 'VW',
      customer: {
        firstName: 'Test',
        lastName: 'Xyz',
        contact: {
          email: 'Testxyz@vw.com',
        },
        address: {
          zip: '12345',
        },
      },
      campaign: {
        id: 'VWCA_IB_DC_25_VWCPOLL_HR',
      },
      vehicles: [
        {
          modelDerivatID: 'VW0701_VW0701',
        },
      ],
    };
    */

    const payload = {
      originCountry: 'CA',
      language: lang.toUpperCase(),
      brand: 'VW',
      customer: {
        firstName: form.firstName,
        lastName: form.lastName,
        contact: {
          email: form.email,
        },
        address: {
          zip: form.postal,
        },
      },
      campaign: {
        id: appConfig.campaignId,
      },
      vehicles: [
        {
          modelDerivatID: form.model,
        },
      ],
    };

    const response = await axios.post(
      appConfig.api.hr,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      },
    );

    return response.data;
  }
}
